import { NgModule } from '@angular/core';
import { HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';

import { NgScrollbarModule } from 'ngx-scrollbar';

// Import routing module
import { AppRoutingModule } from './app-routing.module';

// Import app component
import { AppComponent } from './app.component';

// Import containers
import { DefaultFooterComponent, DefaultHeaderComponent, DefaultLayoutComponent } from './containers/default-layout';
import { PublicFooterComponent, PublicHeaderComponent, PublicLayoutComponent, PublicMenuComponent } from './containers/public-layout'

import {
  AccordionModule,
  AvatarModule,
  BadgeModule,
  BreadcrumbModule,
  ButtonGroupModule,
  ButtonModule,
  CardModule,
  DropdownModule,
  FooterModule,
  FormModule,
  GridModule,
  HeaderModule,
  ListGroupModule,
  NavModule,
  ProgressModule,
  SharedModule,
  SidebarModule,
  TabsModule,
  UtilitiesModule,
  CarouselModule,
  CollapseModule,
  PaginationModule,
  PlaceholderModule,
  PopoverModule,
  SpinnerModule,
  TableModule,
  TooltipModule,
} from '@coreui/angular';

import { IconModule, IconSetService } from '@coreui/icons-angular';
import { CategoriaModule } from './views/pages/categoria/categoria.module';
import { AngularToastifyModule, ToastService } from 'angular-toastify';
import { StorageService } from './services/storage.service';
import { ApiService } from './api/api.service';
import { CoreService } from './services/core-service/core-service.service'
import { ValidarAuthService } from './services/validar-auth/validar-auth.service'
import { NgxWebstorageModule } from 'ngx-webstorage';
import { NgxEditorModule } from 'ngx-editor';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { NgSelectModule } from '@ng-select/ng-select';

const containers = [
  DefaultFooterComponent,
  DefaultHeaderComponent,
  DefaultLayoutComponent,
  PublicFooterComponent,
  PublicHeaderComponent,
  PublicLayoutComponent,
  PublicMenuComponent
];

@NgModule({
  declarations: [
    AppComponent,
    ...containers],
  imports: [
    AccordionModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AvatarModule,
    BreadcrumbModule,
    FooterModule,
    DropdownModule,
    GridModule,
    HeaderModule,
    SidebarModule,
    IconModule,
    NavModule,
    ButtonModule,
    FormModule,
    UtilitiesModule,
    ButtonGroupModule,
    ReactiveFormsModule,
    SidebarModule,
    SharedModule,
    TabsModule,
    ListGroupModule,
    ProgressModule,
    BadgeModule,
    ListGroupModule,
    CardModule,
    NgScrollbarModule,
    CategoriaModule,
    CarouselModule,
    CollapseModule,
    PaginationModule,
    PlaceholderModule,
    PopoverModule,
    SpinnerModule,
    TableModule,
    TooltipModule,
    AngularToastifyModule,
    NgxEditorModule,
    NgxWebstorageModule.forRoot({
      prefix: 'gt',
      caseSensitive: true,
      separator: '-'
    }),
    SweetAlert2Module.forRoot(),
    NgSelectModule
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    IconSetService,
    Title,
    ToastService,
    StorageService,
    ApiService,
    CoreService,
    ValidarAuthService
  ],
  bootstrap: [AppComponent],
  exports: []
})
export class AppModule { }
